import PageBox from "PFComponents/box/page_box";
import { Button } from "PFComponents/button";
import ButtonLink from "PFComponents/button/button_link";
import DropdownButton from "PFComponents/dropdown/dropdown_button";
import { InputFieldSet } from "PFComponents/text/input_field_set";
import { ApiRoute } from "PFCore/utilities/routes";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import css from "./edit_allowed_domains_page.module.scss";

const EditAllowedDomainsPage = ({ allowedDomain, options }) => {
  const { t } = useTranslation("admin");
  const history = useHistory();
  const isNew = !allowedDomain?.id;
  const index = ["", ...options].indexOf(allowedDomain?.obligatory_signin);
  const [domain, setDomain] = useState(allowedDomain?.domain || "");
  const [selectedIndex, setSelectedIndex] = useState(index > -1 ? index : 0);
  const [error, setError] = useState("");

  const mappedOptions = options.map((option, index) => ({
    id: index + 1,
    displayElement: <div>{option}</div>,
    item: option
  }));

  const signInOptions = [
    {
      id: 0,
      displayElement: <div>{t("allowedDomains.edit.none")}</div>,
      item: ""
    },
    ...mappedOptions
  ];

  const handleUpdateAllowedDomain = () => {
    const { id } = allowedDomain;
    let payload = {
      domain: domain,
      obligatory_signin: signInOptions[selectedIndex].item
    };

    if (!isNew) {
      payload = { ...payload, id };
    }

    $.ajax({
      url: ApiRoute(isNew ? "/api/admin/allowed_domains" : `/api/admin/allowed_domains/${id}`),
      method: isNew ? "POST" : "PUT",
      api_version: 1,
      data: payload
    })
      .then(() => history.push(`/admin/allowed_domains`))
      .catch((error) => setError(error?.responseJSON?.errors));
  };

  return (
    <div>
      <h1 className={css.header}>
        {isNew ? t("allowedDomains.edit.createTitle") : t("allowedDomains.edit.editTitle")}
      </h1>
      <PageBox style={{ padding: 20, maxWidth: 900 }}>
        <div className={css.lineWrapper}>
          <div className={css.left}>{t("allowedDomains.edit.domain")}</div>
          <div className={css.right}>
            <InputFieldSet
              type="text"
              value={domain}
              style={{ width: "100%" }}
              onChange={setDomain}
              error={error?.domain}
            />
          </div>
        </div>
        <div className={css.lineWrapper}>
          <div className={css.left}>{t("allowedDomains.edit.obligatorySignin")}</div>
          <div className={css.right}>
            <DropdownButton
              options={signInOptions}
              dropDownStyle={{
                width: 300,
                maxWidth: 300,
                minWidth: 300,
                left: 0
              }}
              buttonKind="secondary"
              handleChange={(selected) =>
                setSelectedIndex(signInOptions.find((option) => option.item === selected).id)
              }
              popperOptions={{
                placement: "bottom-start"
              }}
            >
              <div>{signInOptions[selectedIndex].displayElement}</div>
            </DropdownButton>
          </div>
        </div>
        <div className={css.formButtonsWrapper}>
          <ButtonLink kind="secondary" href="/admin/allowed_domains">
            {t("translation:cancel")}
          </ButtonLink>
          <Button kind="primary" onClick={handleUpdateAllowedDomain}>
            {isNew ? t("translation:create") : t("translation:update")}
          </Button>
        </div>
      </PageBox>
    </div>
  );
};

EditAllowedDomainsPage.propTypes = {
  allowedDomain: PropTypes.shape({
    domain: PropTypes.string,
    id: PropTypes.number,
    obligatory_signin: PropTypes.string
  }),
  options: PropTypes.arrayOf(PropTypes.string)
};

export default EditAllowedDomainsPage;
